import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { Transit } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface CreateTransitProps {
  transit: Partial<Transit>;
}

export const useCreateTransit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ transit }: CreateTransitProps): Promise<Transit> => {
      const { name, customer, template, MRN, group } = transit as any;
      return request({
        path: `transits/add`,
        method: 'POST',
        authenticate: true,
        dataObject: { name, customer, template, MRN, group },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transits'] });
      toast.success(`New transit was uploaded!`);
    },
    onError: (error) => {
      const originalError = (error as any).response?.data?.originalError;
      showErrorToast(error, originalError || `Error uploading the transit!`);
    },
  });
};
